module.exports = __webpack_public_path__ + "media/images/landing/illust/graph-d5e178528195f7d4a33cb3c7dfbefe00.png";